<template>
  <svg xmlns="http://www.w3.org/2000/svg">
    <path
      d="m14.999 1h-5.99998v3h-3c-1.1 0-2 .9-2 2v4.62l-1.29.42c-.63.19-.81.84-.66 1.28l1.9 6.68h.05c1.6 0 3.02-.88 4-2 .98 1.12 2.39998 2 3.99998 2s3.02-.88 4-2c.98 1.12 2.4 2 4 2h.05l1.91-6.68c.11-.37.04-1.06-.66-1.28l-1.3-.42v-4.62c0-1.1-.9-2-2-2h-3zm-8.99998 8.97v-3.97h11.99998v3.97l-6-1.97zm9.99998 9.71c-1.22.85-2.61 1.28-4 1.28s-2.77998-.43-3.99998-1.28c-1.22.85-2.61 1.32-4 1.32h-2v2h2c1.38 0 2.74-.35 4-.99 1.26.64 2.62998.97 3.99998.97s2.74-.32 4-.97c1.26.65 2.62.99 4 .99h2v-2h-2c-1.39 0-2.78-.47-4-1.32z"
    />
  </svg>
</template>
